<template>
  <section class="max-w-xl mx-auto">
    <div class="flex-row flex">
      <MembershipList class="w-1/3" />
      <div class="w-2/3 mx-4 flex">
        <div class="w-1/2">
          <h2 v-text="'Add to:'" />
          <MembershipGroupList :selected-membership-groups="addTo" />
        </div>
        <div class="w-1/2">
          <h2 v-text="'Remove from:'" />
          <MembershipGroupList :selected-membership-groups="removeFrom" />
        </div>
      </div>
    </div>
    <div class="flex justify-center my-6">
      <button
        type="button"
        class="btn-sm btn--link btn mr-6"
        @click="previousTab"
        v-text="'Back'"
      />
      <button
        type="button"
        class="btn-sm btn-success btn"
        @click="$emit('confirmed')"
        v-text="'Save'"
      />
    </div>
  </section>
</template>

<script type="text/babel">
import TabNavigation from 'Membership/Resources/assets/js/mixins/tab-navigation'
import MembershipList from './MembershipList'
import MembershipGroupList from './MembershipGroupList'

export default {
  name: 'ConfirmGroups',
  components: {
    MembershipGroupList,
    MembershipList,
  },
  mixins: [TabNavigation],
  props: {
    edits: {
      type: Object,
      required: true,
    },
  },
  computed: {
    addTo() {
      return this.edits.hasOwnProperty('add_to') ? this.edits.add_to : []
    },
    removeFrom() {
      return this.edits.hasOwnProperty('remove_from') ? this.edits.remove_from : []
    },
  },
}
</script>
